import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ProjectAdminGuard } from './core/guard/route-guard/project-admin.guard';
import { SuperAdminGuard } from './core/guard/route-guard/super-admin.guard';
import { RoleGuard } from './core/guard/route-guard/role.guard';
import { ProjectAccessGuard } from './core/guard/route-guard/project-access.guard';

const ProjectAdminPageGuards = [MsalGuard, RoleGuard, ProjectAdminGuard];
const SuperAdminGuards = [MsalGuard, RoleGuard, SuperAdminGuard];
// const ProjectAccessGuards = [MsalGuard, RoleGuard, ProjectAccessGuard];
// const ProjectAccessGuards = [MsalGuard, RoleGuard];
const ProjectAccessGuards = [MsalGuard];
// const AllAccessGuards = [MsalGuard, RoleGuard];
const AllAccessGuards = [MsalGuard];


export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((res) => res.HomeComponent),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Home' },
  },
  {
    path: 'admin',
    //canActivate: ProjectAdminPageGuards,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/admin/admin.component').then(
            (res) => res.AdminComponent
          ),
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./pages/admin/form/form-builder.component').then(
            (res) => res.FormBuilderComponent
          ),
      },
      {
        path: 'activity-logs',
        loadComponent: () =>
          import('./pages/admin/activity-logs/activity-logs.component').then(
            (res) => res.ActivityLogsComponent
          ),
      },
      {
        path: 'file-uploads',
        children: [
          {
            path: '4d',
            loadComponent: () =>
              import(
                './pages/admin/upload-image-files/upload-image-files-page.component'
              ).then((res) => res.UploadImageFilesPageComponent),
          },
          {
            path: 'report-upload',
            loadComponent: () =>
              import(
                './pages/admin/upload-reports/upload-reports.component'
              ).then((res) => res.UploadReportsComponent),
            canActivate: ProjectAccessGuards,
          },
          {
            path: 'video-upload',
            loadComponent: () =>
              import(
                './pages/admin/upload-videos/upload-videos.component'
              ).then((res) => res.UploadVideosComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'error-page',
    loadComponent: () =>
      import('./pages/error-page/error-page.component').then(
        (res) => res.ErrorPageComponent
      ),
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./pages/failed/failed.component').then(
        (res) => res.FailedComponent
      ),
  },
  {
    path: 'no-access',
    loadComponent: () =>
      import('./pages/no-access/no-access/no-access.component').then(
        (res) => res.NoAccessComponent
      ),
  },
  {
    path: 'materials-planning',
    loadComponent: () =>
      import('./pages/materials-planning/materials-planning.component').then(
        (res) => res.MaterialsPlanningComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Materials Planning' },
  },
  {
    path: 'vdr-status',
    loadComponent: () =>
      import('./pages/vdr-status/vdr-status.component').then(
        (res) => res.VdrStatusComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'VDR Status' },
  },
  {
    path: 'construction-status',
    loadComponent: () =>
      import('./pages/construction-status/construction-status.component').then(
        (res) => res.ConstructionManagementComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Construction Status' },
  },
  {
    path: 'hse',
    loadComponent: () =>
      import('./pages/hse/hse.component').then((res) => res.HseComponent),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'HSE' },
  },
  {
    path: 'purchase-order-tracking',
    loadComponent: () =>
      import('./pages/commodity-tracking/commodity-tracking.component').then(
        (res) => res.CommodityTrackingComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Purchase Order Tracking' },
  },
  {
    path: 'engineering-status',
    loadComponent: () =>
      import('./pages/document-control/document-control.component').then(
        (res) => res.DocumentControlComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Engineering Status' },
  },
  {
    path: 'project-scheduling',
    loadComponent: () =>
      import('./pages/project-scheduling/project-scheduling.component').then(
        (res) => res.ProjectSchedulingComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Project Scheduling' },
  },
  {
    path: 'delay-tracking',
    loadComponent: () =>
      import('./pages/delay-tracking/delay-tracking.component').then(
        (res) => res.DelayTrackingComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Delay Tracking' },
  },
  {
    path: '3d-viewer',
    loadComponent: () =>
      import('./pages/three-d-viewer/three-d-viewer.component').then(
        (res) => res.ThreeDViewerComponent
      ),
    canActivate: ProjectAccessGuards,
  },
  {
    path: 'procurement-status',
    loadComponent: () =>
      import('./pages/procurement-status/procurement-status.component').then(
        (res) => res.ProcurementStatusComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Procurement Status' },
  },
  {
    path: 's-curve',
    loadComponent: () =>
      import('./pages/scurve/scurve.component').then(
        (res) => res.ScurveComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Overall Progress' },
  },
  {
    path: 'delay-form/:id',
    loadComponent: () =>
      import('./pages/delay-form/delay-form/delay-form.component').then(
        (res) => res.DelayFormComponent
      ),
    canActivate: ProjectAccessGuards,
  },
  {
    path: 'ai-assist',
    loadComponent: () =>
      import('./pages/ai-assist/ai-assist.component').then(
        (res) => res.AiAssistComponent
      ),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Ai-Assist' },
  },
  {
    path: 'project-higlights/:id',
    loadComponent: () =>
      import(
        './pages/project-highlights/highlight-concern-form/highlight-concern-form.component'
      ).then((res) => res.HighlightConcernFormComponent),
    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Project Highlights' },
  },
  {
    path: 'admin-wizard/:id',
    loadComponent: () =>
      import('./pages/admin-wizard/admin-wizard.component').then(
        (res) => res.AdminWizardComponent
      ),
    //canActivate: ProjectAdminPageGuards,
    data: {},
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/landing/landing.component').then(
        (res) => res.LandingComponent
      ),
    canActivate: AllAccessGuards,
    data: { breadcrumb: 'Landing' },
  },
  {
    path: 'assign-user',
    loadComponent: () =>
      import('./pages/assign-user/assign-user.component').then(
        (res) => res.AssignUserComponent
      ),
    //canActivate: ProjectAdminPageGuards,
    data: {},
  },
  {
    path: 'assign-super-admin',
    loadComponent: () =>
      import('./pages/assign-super-admin/assign-super-admin.component').then(
        (res) => res.AssignSuperAdminComponent
      ),
    //canActivate: SuperAdminGuards,
    data: {},
  },
  {
    path: 'onboard-project',
    loadComponent: () =>
      import('./pages/onboard-project/onboard-project.component').then(
        (res) => res.OnboardProjectComponent
      ),
    //canActivate: SuperAdminGuards,
    data: {},
  },
  {
    path: 'dashboard-mapping',
    loadComponent: () =>
      import('./pages/dashboard-mapping/dashboard-mapping.component').then(
        (res) => res.DashboardMappingComponent
      ),
    //canActivate: SuperAdminGuards,
  },
  {
    path: 'forms',

    canActivate: ProjectAccessGuards,
    data: { breadcrumb: 'Form Responses' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/form-responses/form-responses.component').then(
            (res) => res.FormResponsesComponent
          ),
      },
      {
        path: 'responses',
        children: [
          {
            path: 'new/:formId',
            loadComponent: () =>
              import(
                './pages/form-responses/response-detail/response-detail.component'
              ).then((m) => m.ResponseDetailComponent),
            data: { breadcrumb: 'New Response' },
          },
          {
            path: ':responseId',
            loadComponent: () =>
              import(
                './pages/form-responses/response-detail/response-detail.component'
              ).then((m) => m.ResponseDetailComponent),
            data: { breadcrumb: 'Response Details' },
          },
        ],
      },
    ],
  },
];
